import { render, staticRenderFns } from "./CuratorUpdateModal.vue?vue&type=template&id=32d9a657&scoped=true&"
import script from "./CuratorUpdateModal.vue?vue&type=script&lang=js&"
export * from "./CuratorUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9a657",
  null
  
)

export default component.exports